<template>

    <div class="d-flex flex-wrap justify-center justify-sm-center justify-md-space-between mt-4">

        <!-- PROFILE BUTTON -->

        <!-- EDIT MODE -->
        <text-editor v-if="editMode && profileButtonVisible"
                     v-model="profileButtonTextModel"
                     hint="Improve profile button text">
            <v-badge
                v-if="editMode && profileButtonVisible"
                color="red"
                overlap
                :content="questionsAvailable"
            >
                <v-btn @click="profileButtonClicked"
                       :dark="isDarkColor(profileButtonColor)"
                       :color="profileButtonColor">
                    {{ data.profile_button_text }}
                </v-btn>
            </v-badge>

        </text-editor>

        <!-- NON EDIT MODE -->
        <div v-if="!editMode && profileButtonVisible">
            <v-tooltip top color="primary" :disabled="!displayEditInfo" :open-delay="500">
                <template v-slot:activator="{ on }">

                    <div v-on="on">
                        <v-badge
                            color="red"
                            overlap
                            :content="questionsAvailable"
                        >
                            <v-btn
                                @click="profileButtonClicked"
                                :dark="isDarkColor(profileButtonColor)"
                                :color="profileButtonColor">
                                {{ profileButtonText }}
                            </v-btn>

                        </v-badge>
                    </div>
                </template>
                Button text can be edited in Sub Panel Landing Page Templates
            </v-tooltip>
        </div>

        <!-- COMMUNITY BUTTON -->

        <!-- EDIT MODE -->
        <text-editor v-if="editMode && communityButtonVisible"
                     v-model="communityButtonTextModel"
                     hint="Community button text">

            <v-btn :color="communityButtonColor"
                   :dark="isDarkColor(communityButtonColor)">
                {{ data.community_button_text }}
            </v-btn>

        </text-editor>

        <!-- NON EDIT MODE -->
        <div v-if="!editMode && communityButtonVisible">
            <v-tooltip top color="primary" :disabled="!displayEditInfo" :open-delay="500">
                <template v-slot:activator="{ on }">

                    <div v-on="on">
                        <v-btn
                            @click="communityButtonClicked"
                            :dark="isDarkColor(communityButtonMuted ? backgroundColor : communityButtonColor)"
                            :text="communityButtonMuted"
                            :color="communityButtonMuted ? '' : communityButtonColor">
                            {{ data.community_button_text }}
                        </v-btn>
                    </div>
                </template>
                Button text can be edited in Sub Panel Landing Page Templates
            </v-tooltip>
        </div>

        <!-- SUPPORT BUTTON -->

        <!-- EDIT MODE -->
        <text-editor v-if="editMode && supportButtonVisible"
                     v-model="supportButtonTextModel"
                     hint="Support button text">

            <v-btn text :dark="isDarkColor(backgroundColor)">
                {{ data.support_button_text }}
            </v-btn>

        </text-editor>

        <!-- NON EDIT MODE -->
        <div v-if="!editMode && supportButtonVisible">
            <v-tooltip top color="primary" :disabled="!displayEditInfo" :open-delay="500">
                <template v-slot:activator="{ on }">

                    <div v-on="on">
                        <v-btn
                            @click="supportButtonClicked"
                            text
                            :dark="isDarkColor(backgroundColor)">
                            {{ supportButtonText }}
                        </v-btn>
                    </div>
                </template>
                Button text can be edited in Sub Panel Landing Page Templates
            </v-tooltip>
        </div>

    </div>
</template>

<script>

import TextEditor from "../TextEditor";
import colorMixin from "../DynamicProflingQuestions/colorMixin";

export default {

    mixins: [colorMixin],

    components: {
        TextEditor
    },

    props: {
        editMode: {
            type: Boolean,
            required: false,
            default: false,
        },
        pageType: {
            type: String,
            required: true,
        },
        supportButtonText: {
            type: String,
            required: true,
        },
        profileButtonText: {
            type: String,
            required: true,
        },
        communityButtonText: {
            type: String,
            required: true,
        },
        backgroundColor: {
            type: String,
            required: true,
        },
        profileButtonColor: {
            type: String,
            required: false,
        },
        communityButtonColor: {
            type: String,
            required: false,
        },
        showSupportButton: {
            type: Boolean,
            required: true,
        },
        showCommunityButton: {
            type: Boolean,
            required: true,
        },
        showProfileButton: {
            type: Boolean,
            required: true,
        },
        questionsAvailable: {
            type: Number,
            required: false,
            default: 0
        },
        communityUrl: {
            type: String,
            required: true,
        },
        supportEmail: {
            type: String,
            required: true,
        },
        displayEditInfo: {
            type: Boolean,
            required: false,
            default: false,
        }
    },

    data() {
        return {
            data: {
                profile_button_text: null,
                community_button_text: null,
                support_button_text: null,
            },
            profileButtonEditorModel: false,
            communityButtonEditorModel: false,
            supportButtonEditorModel: false,
            noProfileServices: [
                'proxy-detected',
                'out-of-country',
                'security',
                'privacy',
                'terms',
                'cookies',
                'unsubscribe',
                'unsubscribe-confirmed',
                'password-reset',
                'password-reset-confirmed',
                'registration',
                'registration-complete'
            ],

            noCommunityServices: ['proxies',
                'out-of-country',
                'security',
                'privacy',
                'terms',
                'cookies',
                'unsubscribe',
                'unsubscribe-confirmed',
                'registration'
            ],

            noSupportServices: [
                'privacy',
                'terms',
                'cookies',
                'password-reset',
                'password-reset-confirmed'
            ],
        }
    },

    mounted() {
        this.data.profile_button_text = this.profileButtonText;
        this.data.community_button_text = this.communityButtonText;
        this.data.support_button_text = this.supportButtonText;
    },

    watch: {
        profileButtonText(value) {
            this.data.profile_button_text = value;
        },

        communityButtonText(value) {
            this.data.community_button_text = value;
        },

        supportButtonText(value) {
            this.data.support_button_text = value;
        }
    },

    computed: {

        profileButtonTextModel: {
            get() {
                return this.profileButtonText;
            },
            set(value) {
                this.data.profile_button_text = value;
                this.emitObject();
            }
        },

        communityButtonTextModel: {
            get() {
                return this.communityButtonText;
            },
            set(value) {
                this.data.community_button_text = value;
                this.emitObject();
            }
        },

        communityButtonMuted() {

            if (['project-entry'].includes(this.pageType)) return true;

            return this.profileButtonVisible;
        },

        supportButtonTextModel: {
            get() {
                return this.supportButtonText;
            },
            set(value) {
                this.data.support_button_text = value;
                this.emitObject();
            }
        },

        profileButtonVisible() {

            if (['quota', 'profile', 'completed','acceptance','finished','maintenance'].includes(this.pageType) === false) {
                return false;
            }

            if (this.editMode) {
                return true;
            }

            return this.showProfileButton && this.profileButtonText.length > 0;
        },

        communityButtonVisible() {
            if (this.noCommunityServices.includes(this.pageType)) return false;
            if (this.communityButtonText.length === 0) return false;
            return this.showCommunityButton;
        },

        supportButtonVisible() {
            if (this.noSupportServices.includes(this.pageType)) return false;
            return this.showSupportButton && this.supportButtonText;
        },
    },

    methods: {

        supportButtonClicked() {
            if (this.editMode) {
                this.supportButtonEditorModel = true;
            } else {
                this.sendToUrl('mailto: ' + this.supportEmail, true);
            }
        },

        communityButtonClicked() {
            if (this.editMode) {
                this.communityButtonEditorModel = true;
            } else {
                this.sendToUrl(this.communityUrl);
            }
        },

        profileButtonClicked() {
            if (this.editMode) {
                this.profileButtonEditorModel = true;
            } else {
                this.$emit('profile');
            }
        },

        emitObject() {
            this.$emit('change:subPanelTranslations', this.data);
        }
    }
}
</script>
